import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MagArtiAcquistiModel, MagazziniArticoliAcquisti, ModelNumDecimal } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniArticoliAcquistiService extends CrudGenericsService<MagazziniArticoliAcquisti, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniArticoliAcquisti`);
    this.base = `${env.apiUrl}/api/MagazziniArticoliAcquisti/`;
  }

  GetMagArtAcquistiModel_ByRdA(id_rda: number): Observable<MagArtiAcquistiModel[]> {
    const u = `${this.base}GetMagArtAcquistiModel_ByRdA?id=${id_rda}`;
    return this.http.get<MagArtiAcquistiModel[]>(u);
  }
  Upd_QtaCaricata(idMagArtAcquisto: number, qtaCaricata: number) {
    const model: ModelNumDecimal = {
      Decimal: qtaCaricata,
      Value: idMagArtAcquisto,
    };
    const u = `${this.base}Upd_QtaCaricata`;
    return this.http.post(u, model);
  }
}
